// Components
import AppFooter from '../../components/app-footer'
import AppPageFooter from '../../components/app-page-footer'

export default
{
    name: 'app-page',

    components:
    {
        AppFooter,
        AppPageFooter
    },

    watch:
    {
        ready: 'onReadyChange'
    },

    data()
    {
        return {
            ready: false
        }
    },

    created()
    {
        this.eventHub.$on('window:resize', this.onResize)
        this.eventHub.$on('book-restaurant:iframes-loaded', this.onIframesLoaded)
        this.eventHub.$on('application:scroll-enabled', this.onResize)
    },

    mounted()
    {
        this.ready = true
    },

    destroyed()
    {
        this.eventHub.$off('window:resize', this.onResize)
        this.eventHub.$off('book-restaurant:iframes-loaded', this.onIframesLoaded)
        this.eventHub.$off('application:scroll-enabled', this.onResize)
    },

    methods:
    {
        // WATCHERS
        onReadyChange()
        {
            if (this.ready)
            {
                this.eventHub.$emit('page:ready', this.ready)
            }
        },

        // Events
        onResize()
        {
            if (this.$el.offsetHeight > 0)
            {
                this.eventHub.$emit('page:set-height', this.$el.offsetHeight)
            }
        },

        onIframesLoaded()
        {
            this.onResize()
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/mixins/app-page/index.js